import { render, staticRenderFns } from "./Mechanism.vue?vue&type=template&id=1a3d5134&scoped=true"
import script from "./Mechanism.vue?vue&type=script&lang=js"
export * from "./Mechanism.vue?vue&type=script&lang=js"
import style0 from "./Mechanism.vue?vue&type=style&index=0&id=1a3d5134&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_5a36e3d9a1016b548fda15b2542a0eed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3d5134",
  null
  
)

export default component.exports